'use strict';

var Decorator = require('utils/decoration');
var i18n = require('utils/i18n');
var Log = require('utils/log');
var Tiles = require('components/dashboard/tiles/abstract_tile');
var TileLayoutView = require('components/dashboard/views/tile_layout_view');

var DashboardView = Marionette.LayoutView.extend({
    template: require('components/dashboard/templates/dashboard_layout'),

    regions: function (options) {
        // no tiles? -> no regions
        if (!options.tiles) {
            return {};
        }

        var regions = {};
        for (var idx = 0; idx < options.tiles.length; idx++) {
            var t = options.tiles[idx];
            if (!t.display) {
                options.tiles.splice(idx, 1);
                idx -= 1;
                continue;
            }
            regions['region-' + idx] = '#js-tile-region-' + idx;
            options.tiles[idx].region = 'region-' + idx;
        }

        return regions;
    },

    ui: {
        fullscreen: '.js-fullscreen',
        refresh: '#js-refresh-dashboard',
    },

    events: {
        'click @ui.refresh': 'reloadDashboard',
    },

    childEvents: {
        'toggle:fullscreen': 'toggleFullscreen',
        'update:slideshow': 'updateSlideshow',
        'update:tile:state': 'updateTileState',
    },

    toggleFullscreen: function (_view, tileID) {
        if (this.tileInFullscreenID === undefined) {
            this.tileInFullscreenID = tileID;
            $('.dashboard-grid').attr('class', 'dashboard-no-grid');
            $('article.card-box').hide();
            $('#js-tile-region-' + tileID)
                .show()
                .addClass('full-height');
            $('.fa-expand').addClass('fa-compress').removeClass('fa-expand');
            window.scrollTo(0, 0);
        } else {
            $('.dashboard-no-grid').attr('class', 'dashboard-grid');
            $('#js-tile-region-' + tileID).removeClass('full-height');
            $('article.card-box').show();
            $('.fa-compress').addClass('fa-expand').removeClass('fa-compress');
            this.tileInFullscreenID = undefined;
        }
    },

    initialize: function (options) {
        this.tiles = options.tiles;
        this.tileInFullscreenID = undefined;
        // Extend tile library with custom tiles from plugins.js
        if (window.SDE_plugins && window.SDE_plugins.dashboard && window.SDE_plugins.dashboard.tiles) {
            _.each(window.SDE_plugins.dashboard.tiles, function (tileObject, tileName) {
                Tiles.Library[tileName] = function (tileConfig) {
                    return Tiles.CreateTile(tileObject, tileConfig);
                };
            });
        }
    },

    serializeData: function () {
        var tiles = this.tiles;
        if (this.tileInFullscreenID != undefined) {
            tiles = [this.tiles[this.tileInFullscreenID]];
        }
        return {
            hasTiles: this.tiles.length > 0,
            tiles: tiles,
            isFullscreen: this.tileInFullscreenID != undefined,
        };
    },

    onShow: function () {
        _.each(
            this.tiles,
            function (tile, idx) {
                tile.loadingID = '#view' + idx;
                Decorator.displayLoading(true, tile.loadingID);
            },
            this
        );
        this.initializeTiles(this.tiles);
    },

    initializeTiles: function (tileConfigurations) {
        var def = $.Deferred();
        var tileCount = tileConfigurations.length;

        var showTile = function (tile, data, status) {
            Decorator.displayLoading(false, tile.definition.loadingID);
            self.showChildView(tile.definition.region, new TileLayoutView({ tile: tile, data: data, status: status }));
            tileCount -= 1;
            if (tileCount === 0) {
                def.resolve(true);
            }
        };

        var self = this;
        _.each(tileConfigurations, function (tConfig, tiles) {
            if (!Tiles.Library[tConfig.type]) {
                // This should not happen in prod. Tile is either not defined or was not added to Library.
                // check abstract_tile.js or plugin.js, if this is a tile from a plugin
                Log.assert(false);

                var t = Tiles.Library['error'](tConfig);
                showTile(
                    t,
                    {
                        title: i18n.TR('Unbekannter Kacheltyp'),
                        color_class: 'box-color-error',
                    },
                    Tiles.FETCH_STATUS.ERROR
                );

                return;
            }

            var tile = Tiles.Library[tConfig.type](tConfig, tiles);
            tile.link = tile.getLink();
            tile.update(showTile);
        });
        return def;
    },

    updateTileState: function (_view, callback) {
        callback(this.tiles[parseInt(_view._parent.options.el.split('-')[3])]);
    },

    updateSlideshow: function (view, slideShowID, slide) {
        this.updateTileTitle(view, slide.definition.title || '');
        if (slide.getLink()) {
            $('#js-tile-link-' + slideShowID).attr('href', slide.getLink());
        }
    },

    reloadDashboard: function () {
        if (this.tileInFullscreenID !== undefined) {
            // force update and refresh this tile only
            var fullscreenTileConfig = this.tiles[this.tileInFullscreenID];
            var tile = Tiles.Library[fullscreenTileConfig.type](fullscreenTileConfig, this.tiles);
            tile.update(undefined, undefined, true);
            return;
        }
        var controller = this.options.controller;
        this.destroy();
        controller.showDashboard();
    },
});

module.exports = DashboardView;

// TODO: move somewhere else
//
// Default dashboard strings for translation
//
// - i18n.TR('Wettervorhersage')
// - i18n.TR('Datenpunkt')
//
// - i18n.TR('Durchfluss (gesamt)')
// - i18n.TR('Leistung (gesamt)')
// - i18n.TR('Vorlauftemperatur (Durchschnitt)')
// - i18n.TR('Rücklauftemperatur (Durchschnitt)')
// - i18n.TR('Geräteanzahl')
